var _desc, _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _use, _use2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIllustration3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "281px",
    height: "145px",
    viewBox: "0 0 281 145",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "illustration-3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern-1",
    width: 4,
    height: 4,
    x: 17,
    y: 100,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image-2"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image-2",
    width: 4,
    height: 4,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAYAAACp8Z5+AAAABGdBTUEAALGOfPtRkwAAAB1JREFUCB1j/A8EDBDACKKYoBw4xQJkgWVgIhgqAAb3BAgldYidAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.5,9.5 L10.5,9.5",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 261,
    height: 1,
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M259.5,0.5 L22.5,0.5",
    id: "path-5"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 237,
    height: 1,
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Features-1",
    transform: "translate(-1060.000000, -359.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "illustration-3",
    transform: "translate(1060.000000, 359.000000)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5,144.5 L280.5,144.5 L280.5,19.5 L0.5,19.5 L0.5,144.5 Z",
    id: "Stroke-2",
    stroke: "#FFFFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23,104.5 C22.1715729,104.5 21.5,105.171573 21.5,106 L21.5,122 C21.5,122.828427 22.1715729,123.5 23,123.5 L39,123.5 C39.8284271,123.5 40.5,122.828427 40.5,122 L40.5,106 C40.5,105.171573 39.8284271,104.5 39,104.5 L23,104.5 Z",
    id: "Rectangle",
    stroke: "#FFFFFF",
    opacity: 0.400000006
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63,104.5 C62.1715729,104.5 61.5,105.171573 61.5,106 L61.5,122 C61.5,122.828427 62.1715729,123.5 63,123.5 L79,123.5 C79.8284271,123.5 80.5,122.828427 80.5,122 L80.5,106 C80.5,105.171573 79.8284271,104.5 79,104.5 L63,104.5 Z",
    id: "Rectangle",
    stroke: "#FFFFFF",
    opacity: 0.400000006
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M103,104.5 C102.171573,104.5 101.5,105.171573 101.5,106 L101.5,122 C101.5,122.828427 102.171573,123.5 103,123.5 L119,123.5 C119.828427,123.5 120.5,122.828427 120.5,122 L120.5,106 C120.5,105.171573 119.828427,104.5 119,104.5 L103,104.5 Z",
    id: "Rectangle",
    stroke: "#FFFFFF",
    opacity: 0.400000006
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M143,104.5 C142.171573,104.5 141.5,105.171573 141.5,106 L141.5,122 C141.5,122.828427 142.171573,123.5 143,123.5 L159,123.5 C159.828427,123.5 160.5,122.828427 160.5,122 L160.5,106 C160.5,105.171573 159.828427,104.5 159,104.5 L143,104.5 Z",
    id: "Rectangle",
    stroke: "#FFFFFF",
    opacity: 0.400000006
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M183,104.5 C182.171573,104.5 181.5,105.171573 181.5,106 L181.5,122 C181.5,122.828427 182.171573,123.5 183,123.5 L199,123.5 C199.828427,123.5 200.5,122.828427 200.5,122 L200.5,106 C200.5,105.171573 199.828427,104.5 199,104.5 L183,104.5 Z",
    id: "Rectangle",
    stroke: "#FFFFFF",
    opacity: 0.400000006
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M223,104.5 C222.171573,104.5 221.5,105.171573 221.5,106 L221.5,122 C221.5,122.828427 222.171573,123.5 223,123.5 L239,123.5 C239.828427,123.5 240.5,122.828427 240.5,122 L240.5,106 C240.5,105.171573 239.828427,104.5 239,104.5 L223,104.5 Z",
    id: "Rectangle",
    stroke: "#FFFFFF",
    opacity: 0.400000006
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M263,104.5 C262.171573,104.5 261.5,105.171573 261.5,106 L261.5,122 C261.5,122.828427 262.171573,123.5 263,123.5 L279,123.5 C279.828427,123.5 280.5,122.828427 280.5,122 L280.5,106 C280.5,105.171573 279.828427,104.5 279,104.5 L263,104.5 Z",
    id: "Rectangle",
    stroke: "#FFFFFF",
    opacity: 0.400000006
  })), /*#__PURE__*/React.createElement("path", {
    d: "M39,104 C40.1045695,104 41,104.895431 41,106 L41,122 C41,123.104569 40.1045695,124 39,124 L23,124 C21.8954305,124 21,123.104569 21,122 L21,106 C21,104.895431 21.8954305,104 23,104 L39,104 Z M79,104 C80.1045695,104 81,104.895431 81,106 L81,122 C81,123.104569 80.1045695,124 79,124 L63,124 C61.8954305,124 61,123.104569 61,122 L61,106 C61,104.895431 61.8954305,104 63,104 L79,104 Z M119,104 C120.104569,104 121,104.895431 121,106 L121,122 C121,123.104569 120.104569,124 119,124 L103,124 C101.895431,124 101,123.104569 101,122 L101,106 C101,104.895431 101.895431,104 103,104 L119,104 Z M159,104 C160.104569,104 161,104.895431 161,106 L161,122 C161,123.104569 160.104569,124 159,124 L143,124 C141.895431,124 141,123.104569 141,122 L141,106 C141,104.895431 141.895431,104 143,104 L159,104 Z M199,104 C200.104569,104 201,104.895431 201,106 L201,122 C201,123.104569 200.104569,124 199,124 L183,124 C181.895431,124 181,123.104569 181,122 L181,106 C181,104.895431 181.895431,104 183,104 L199,104 Z M239,104 C240.104569,104 241,104.895431 241,106 L241,122 C241,123.104569 240.104569,124 239,124 L223,124 C221.895431,124 221,123.104569 221,122 L221,106 C221,104.895431 221.895431,104 223,104 L239,104 Z M279,104 C280.104569,104 281,104.895431 281,106 L281,122 C281,123.104569 280.104569,124 279,124 L263,124 C261.895431,124 261,123.104569 261,122 L261,106 C261,104.895431 261.895431,104 263,104 L279,104 Z",
    id: "Combined-Shape",
    fill: "url(#pattern-1)",
    style: {
      mixBlendMode: "exclusion"
    },
    opacity: 0.200000003
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23,40.5 C22.1715729,40.5 21.5,41.1715729 21.5,42 L21.5,58 C21.5,58.8284271 22.1715729,59.5 23,59.5 L39,59.5 C39.8284271,59.5 40.5,58.8284271 40.5,58 L40.5,42 C40.5,41.1715729 39.8284271,40.5 39,40.5 L23,40.5 Z",
    id: "Rectangle",
    stroke: "#FFFFFF",
    opacity: 0.400000006
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M63,40.5 C62.1715729,40.5 61.5,41.1715729 61.5,42 L61.5,58 C61.5,58.8284271 62.1715729,59.5 63,59.5 L79,59.5 C79.8284271,59.5 80.5,58.8284271 80.5,58 L80.5,42 C80.5,41.1715729 79.8284271,40.5 79,40.5 L63,40.5 Z",
    id: "Rectangle",
    stroke: "#FFFFFF",
    opacity: 0.400000006
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M103,40.5 C102.171573,40.5 101.5,41.1715729 101.5,42 L101.5,58 C101.5,58.8284271 102.171573,59.5 103,59.5 L119,59.5 C119.828427,59.5 120.5,58.8284271 120.5,58 L120.5,42 C120.5,41.1715729 119.828427,40.5 119,40.5 L103,40.5 Z",
    id: "Rectangle",
    stroke: "#FFFFFF",
    opacity: 0.400000006
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M143,40.5 C142.171573,40.5 141.5,41.1715729 141.5,42 L141.5,58 C141.5,58.8284271 142.171573,59.5 143,59.5 L159,59.5 C159.828427,59.5 160.5,58.8284271 160.5,58 L160.5,42 C160.5,41.1715729 159.828427,40.5 159,40.5 L143,40.5 Z",
    id: "Rectangle",
    stroke: "#FFFFFF",
    opacity: 0.400000006
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M183,40.5 C182.171573,40.5 181.5,41.1715729 181.5,42 L181.5,58 C181.5,58.8284271 182.171573,59.5 183,59.5 L199,59.5 C199.828427,59.5 200.5,58.8284271 200.5,58 L200.5,42 C200.5,41.1715729 199.828427,40.5 199,40.5 L183,40.5 Z",
    id: "Rectangle",
    stroke: "#FFFFFF",
    opacity: 0.400000006
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M223,40.5 C222.171573,40.5 221.5,41.1715729 221.5,42 L221.5,58 C221.5,58.8284271 222.171573,59.5 223,59.5 L239,59.5 C239.828427,59.5 240.5,58.8284271 240.5,58 L240.5,42 C240.5,41.1715729 239.828427,40.5 239,40.5 L223,40.5 Z",
    id: "Rectangle",
    stroke: "#FFFFFF",
    opacity: 0.400000006
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M263,40.5 C262.171573,40.5 261.5,41.1715729 261.5,42 L261.5,58 C261.5,58.8284271 262.171573,59.5 263,59.5 L279,59.5 C279.828427,59.5 280.5,58.8284271 280.5,58 L280.5,42 C280.5,41.1715729 279.828427,40.5 279,40.5 L263,40.5 Z",
    id: "Rectangle",
    stroke: "#FFFFFF",
    opacity: 0.400000006
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    id: "Path",
    stroke: "#FFFFFF",
    mask: "url(#mask-4)",
    strokeWidth: 2,
    opacity: 0.400000006,
    strokeDasharray: 3,
    xlinkHref: "#path-3"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    id: "Path",
    stroke: "#FFFFFF",
    mask: "url(#mask-6)",
    strokeWidth: 2,
    opacity: 0.400000006,
    strokeDasharray: 3,
    xlinkHref: "#path-5"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustration3);
export default __webpack_public_path__ + "static/media/illustration-3.a849a083a155c3e40c94033f36950c9c.svg";
export { ForwardRef as ReactComponent };